import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MoreIcon from '@mui/icons-material/MoreVert';

import ScrollToColor from './Scroll';

export default function PrimarySearchAppBar() {

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const [hoverHome, setHoverHome] = React.useState(false);
  const [hoverAbout, setHoverAbout] = React.useState(false);
  const [hoverTokenomics, setHoverTokenomics] = React.useState(false);
  const [hoverRoadmap, setHoverRoadmap] = React.useState(false);
  const [hoverAudit, setHoverAudit] = React.useState(false);
  const [hoverWhitepaper, setHoverWhitepaper] = React.useState(false);
  const [hoverRewards, setHoverRewards] = React.useState(false);
  const [hoverSocial, setHoverSocial] = React.useState(false);



  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  function scrollToHome() {
    document.getElementById("home").scrollIntoView({ behavior: "smooth" });
  }

  function scrollToAbout() {
    document.getElementById("about").scrollIntoView({ behavior: "smooth" });
  }

  function scrollToTokenomics() {
    document.getElementById("tokenomics").scrollIntoView({ behavior: "smooth" });
  }

  function scrollToRoadmap() {
    document.getElementById("roadmap").scrollIntoView({ behavior: "smooth" });
  }

  function scrollToAudit() {
    document.getElementById("audit").scrollIntoView({ behavior: "smooth" });
  }

  function scrollToWhitepaper() {
    document.getElementById("whitepaper").scrollIntoView({ behavior: "smooth" });
  }

  function srcollToSocial() {
    document.getElementById("social").scrollIntoView({ behavior: "smooth" });
  }


  const mobileMenuId = 'primary-search-account-menu-mobile';
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem  onClick={handleProfileMenuOpen}>
        <IconButton size="large" color="inherit" onClick={scrollToHome}>
                <Typography>HOME</Typography>
        </IconButton>
      </MenuItem>
      <MenuItem  onClick={handleProfileMenuOpen}>
        <IconButton size="large" color="inherit" onClick={scrollToAbout}>
            <Typography>ABOUT 1RC</Typography>
        </IconButton>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton size="large" color="inherit" onClick={scrollToHome}>
            <Typography>BNB REWARDS</Typography>
        </IconButton>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton size="large" color="inherit" onClick={scrollToTokenomics}>
            <Typography>TOKENOMICS</Typography>
        </IconButton>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton size="large" color="inherit" onClick={scrollToAudit}>
            <Typography>AUDIT</Typography>
        </IconButton>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton size="large" color="inherit" onClick={scrollToRoadmap}>
            <Typography>ROADMAP</Typography>
        </IconButton>
      </MenuItem>
      <MenuItem onClick={handleProfileMenuOpen}>
        <IconButton size="large" color="inherit" onClick={scrollToWhitepaper}>
            <Typography>WHITEPAPER</Typography>
        </IconButton>
      </MenuItem>
  
    </Menu>
  );

  return (
    <Box sx={{ flexGrow: 1 }} style={ { overflow: "hidden" } }>
      <ScrollToColor>
        <AppBar 
          position="sticky" style={{ backgroundColor: '#171324', boxShadow: 'none', marginTop: "1.25 rem", position: "fixed" ,color: "#D0F1FF"}} 
          >
          <Toolbar>
            <Typography
              variant="h5"
              noWrap
              component="div"
              sx={{ display: { sm: 'block' } }}
              width="65px"
            >
              <img src="/logo.png" alt="Logo" border="0" style={{ width: "15%",  minWidth: "70px", marginLeft: "-0.75rem", marginTop: "1rem" }} />
            </Typography>
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
              <IconButton 
                size="large" 
                color="inherit" 
                onClick={scrollToHome}  
                style={ { color: hoverHome ? '#F3BA2F' : '#D0F1FF' } }
                onMouseEnter={() =>  setHoverHome(true)}
                onMouseLeave={() => setHoverHome(false)}
              >
                  <Typography >HOME</Typography>
              </IconButton>
              <IconButton 
                size="large" 
                color="inherit" 
                onClick={scrollToAbout}
                style={ { color: hoverAbout ? '#F3BA2F' : '#D0F1FF' } }
                onMouseEnter={() =>  setHoverAbout(true)}
                onMouseLeave={() => setHoverAbout(false)}
              >
                  <Typography >ABOUT 1RC</Typography>
              </IconButton>
              <IconButton 
                size="large" 
                color="inherit" 
                onClick={scrollToHome}  
                style={ { color: hoverRewards ? '#F3BA2F' : '#D0F1FF' } }
                onMouseEnter={() =>  setHoverRewards(true)}
                onMouseLeave={() => setHoverRewards(false)}
              >
                  <Typography >BNB REWARDS</Typography>
              </IconButton>
              <IconButton 
                size="large"
                color="inherit" 
                onClick={scrollToTokenomics}
                style={ { color: hoverTokenomics ? '#F3BA2F' : '#D0F1FF' } }
                onMouseEnter={() =>  setHoverTokenomics(true)}
                onMouseLeave={() => setHoverTokenomics(false)}
              >
                
                  <Typography >TOKENOMICS</Typography>
              </IconButton>
              <IconButton 
                size="large" 
                color="inherit" 
                onClick={scrollToAudit}
                style={ { color: hoverAudit ? '#F3BA2F' : '#D0F1FF' } }
                onMouseEnter={() =>  setHoverAudit(true)}
                onMouseLeave={() => setHoverAudit(false)}
                >
                  <Typography >AUDIT</Typography>
              </IconButton>
              <IconButton 
                size="large" 
                color="inherit" 
                onClick={scrollToWhitepaper}
                style={ { color: hoverWhitepaper ? '#F3BA2F' : '#D0F1FF' } }
                onMouseEnter={() =>  setHoverWhitepaper(true)}
                onMouseLeave={() => setHoverWhitepaper(false)}
                >
                  <Typography >WHITEPAPER</Typography>
              </IconButton>
              <IconButton 
                size="large" 
                color="inherit" 
                onClick={scrollToRoadmap}
                style={ { color: hoverRoadmap ? '#F3BA2F' : '#D0F1FF' } }
                onMouseEnter={() =>  setHoverRoadmap(true)}
                onMouseLeave={() => setHoverRoadmap(false)}
                >
                  <Typography >ROADMAP</Typography>
              </IconButton>
              <IconButton 
                size="large" 
                color="inherit" 
                onClick={srcollToSocial}
                style={ { color: hoverSocial ? '#F3BA2F' : '#D0F1FF' } }
                onMouseEnter={() =>  setHoverSocial(true)}
                onMouseLeave={() => setHoverSocial(false)}
                >
                  <Typography>SOCIALS</Typography>
              </IconButton>
            </Box>
            <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
              <IconButton
                size="large"
                aria-label="show more"
                aria-controls={mobileMenuId}
                aria-haspopup="true"
                onClick={handleMobileMenuOpen}
                color="inherit"
              >
                <MoreIcon />
              </IconButton>
            </Box>
          </Toolbar>
        </AppBar>
      </ScrollToColor>
      {renderMobileMenu}
    </Box>
  );
}